import React from "react";
import PropTypes from "prop-types";
import "./EorDetails.css";

const fieldLabel = (key) => {
  if (key === "PostFlag") return "Posting status";
  return key
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .replace(/([a-z\d])([A-Z])/g, "$1 $2")
    .replace(/[_-]+/g, " ")
    .replace(/^./, (first) => first.toUpperCase());
};

const postingStatus = {
  P: "Paid",
  C: "Cancelled",
  B: "Block payment",
  V: "Void",
  D: "Dishonored check",
};

const detailRows = (details, path = []) =>
  Object.entries(details).flatMap(([key, value]) => {
    const keys = [...path, key];
    if (value && typeof value === "object") return detailRows(value, keys);
    let display = value == null || value === "" ? "N/A" : String(value);
    if (typeof value === "boolean") display = value ? "Yes" : "No";
    if (key === "PostFlag" && typeof postingStatus[value] === "string") {
      display = postingStatus[value];
    }
    return [
      {
        key: JSON.stringify(keys),
        label: keys.map(fieldLabel).join(" / "),
        value: display,
      },
    ];
  });

function EorDetails({ details }) {
  let parsed = details;
  if (typeof details === "string") {
    try {
      parsed = JSON.parse(details);
    } catch (_) {
      parsed = null;
    }
  }
  const rows = parsed && typeof parsed === "object" ? detailRows(parsed) : [];

  return (
    <section
      className="eor-details"
      aria-label="Electronic official receipt details"
    >
      <h2>EOR details</h2>
      {rows.length ? (
        <dl className="eor-details-list">
          {rows.map((row) => (
            <div className="eor-details-row" key={row.key}>
              <dt>{row.label}</dt>
              <dd>{row.value}</dd>
            </div>
          ))}
        </dl>
      ) : (
        <p className="eor-details-empty">
          Electronic official receipt details are not yet available.
        </p>
      )}
    </section>
  );
}

EorDetails.propTypes = {
  details: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
};

EorDetails.defaultProps = { details: null };

export default EorDetails;
